import { render, staticRenderFns } from "./SerialUnassigned.vue?vue&type=template&id=cf3d9f9a&"
import script from "./SerialUnassigned.vue?vue&type=script&lang=js&"
export * from "./SerialUnassigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports